module.exports = __webpack_public_path__ + "static/media/daniel.627a667d.png";